module.exports = __webpack_public_path__ + "static/media/basemap-01.342ec2db.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/03/01/assets/basemap-01.png
// module id = 482
// module chunks = 0